module.exports = __webpack_public_path__ + "static/media/no-view.0b1ecfc5.svg";